import { render, staticRenderFns } from "./goods-cate-form.vue?vue&type=template&id=62960e49"
import script from "./goods-cate-form.vue?vue&type=script&lang=js"
export * from "./goods-cate-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports